import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { getEmailAttachmentSecurityAction, checkRuleNameAlreadyExists, getEmailRules } from '../../actions/emailRulesAction';
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from 'react-toastify';
import { AssetDropDown } from "../../UiComponents/AssetDropDown";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { useLocation } from "react-router-dom";
import { SBADropDown, SBAComboBox, SBAMultiSelectCheck } from "../../UiComponents/SBADropDown";
import { getCategory } from "../../actions/investmentAction";
import { Modal } from 'react-bootstrap';
import { EmailruleInsertorUpdate, InsertOrUpdateEmailAttachmentSecurity, getEmailrule, CheckEmailRuleNameExists, getEmailAttachmentSecurity } from "../../../config/apiConfig";
import { sbaAxios } from '../../utils/sbaAxios';
import { SBNotify } from "../../utils/sbNotify";
import { getTaxEntitiesAction } from "../../actions/CommonAction";
import { getCrmDocumentTypesAction } from "../../actions/documentAction";
import $ from "jquery";


export const EditEmailRules = () => {


  const params = useParams();
  const locationData = useLocation();
  const dispatch = useDispatch();
  const history = useNavigate();

  const EmailRuleMeta = {
    "EmailRuleId": null,
    "EmailRuleName": null || "",
    "EmailRuleTypeId": null,
    "IsActive": null,
    "FilterFromAddresses": null,
    "FilterToAddresses": null,
    "FilterCCAddresses": null,
    "FilterFromDomains": null,
    "FilterSubjectContains": null,
    "FilterBodyContains": null,
    "FilterAttachmentContains": null,
    "AccountIdList": null,
    "AssetIdList": null,
    "AssetNameList": null,
    "DocumentTypeId": null,
    "DocumentType": null,
    "AccountName": null,
    "ClientName": null,
    "SourceEmail": null,
    "SubjectOverride": null,
    "DateOverideFormat": null,
    "IsAttachmentOnly": null,
    "IsLinkedEmail": null,
    "LinkedEmailFieldId": null,
    "LinkedEmailFieldContain": null,
    "IsStandardConfiguration": null,
    "EmailAttachmentSecurityId": null,
    "Priority": null,
    "DateOverrideBy": null,
    "DateOverrideByName": null,
    "CreatedBy": null,
    "CreatedByName": null,
    "CreatedDate": null,
    "ModifiedBy": null,
    "ModifiedByName": null,
    "ModifiedDate": null
  }
  const PasswordMeta = {
    "AssetType": null,
    "AssetValue": null,
    "AssetId": 0,
    "AssetName": null,
    "AccountTypeId": null,
    "Password": null,
    "EmailAttachmentSecurityId": null
  }
  const entities=localStorage.getItem("Entities");
  const localAssetId =(JSON.parse(entities)).AssetId;
  const Gstate = useSelector(state => { return state; }) || {};
  const AssetListDDL = Gstate.assetDDL.assetList || [];
  const AccountNameList = Gstate.common.TaxEntitiesList || [];
  const DocumentTypesData = Gstate.Documents.crmDocumentTypesData || [];
  const AssetDataItems = Gstate.assetDDL.assetList || [];
  const Category = Gstate.Category.Category || [];
  const EmailRules = Gstate.emailRules.emailRules || [];
  const isEditable = Gstate.authorizationData.isEditable;
  const ActiveTab = locationData.state === null ? 1 : locationData.state;
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [selectedCaterogy, setSelectedCaterogy] = useState({});
  const [emailRule, setEmailRule] = useState(EmailRuleMeta);
  const [securityItem, setSecurityItem] = useState([]);
  const [selectedSecurityItem, setSelectedSecurityItem] = useState();
  const [showModal, setShowModal] = useState(false);
  const [passwordData, setPasswordData] = useState(PasswordMeta);
  const [existingAttachment, setExistingAttachment] = useState(false);
  const [showText, setShowText] = useState(false);
  const [selectedOption, setSelectedOption] = useState("account");
  const [accountName, SetAccountName] = useState([]);
  const [selectedAssetId, setselectedAssetId] = useState(EmailRules[0]?.AssetIdList);
  const [clientAssetId, SetClientAssetId] = useState({ AssetId: EmailRules[0]?.AssetIdList, AssetName: EmailRules[0]?.AssetNameList });
  const [clientDocumentTypeId, SetClientDocumentTypeId] = useState({ DocumentTypeId: EmailRules[0]?.DocumentTypeId, TypeName: EmailRules[0]?.DocumentType });
  const [subjectOverride, SetSubjectOverride] = useState(EmailRules[0]?.SubjectOverride);
  const [dateOverrideFormat, SetDateOverrideFormat] = useState(EmailRules[0]?.DateOverideFormat);
  const [selectedDateOverrideOption, setSelectedDateOverrideOption] = useState("");
  const [isStandardConfiguration, SetIsStandardConfiguration] = useState(EmailRules[0]?.IsStandardConfiguration);
  const [showAttachmentOnly, SetShowAttachmentOnly] = useState("");
  const [linkedEmail, SetLinkedEmail] = useState("");
  const [field, SetField] = useState({});
  const [fieldContains, SetFieldContains] = useState(EmailRules[0]?.LinkedEmailFieldContain);
  const [accounts, setAccounts] = useState([]);
  const toggleTextVisibility = () => {
    setShowText(!showText);
  };
  const getSecurityList = () => {
    sbaAxios({ method: 'get', url: `${getEmailAttachmentSecurity}` }).then(response => {
      setSecurityItem(response);
    }).catch(error => {
      console.log("error fetching EmailAttachmentSecurity", error)
    });
  };
  useEffect(() => {
    setAccounts([...AccountNameList])
  }, [AccountNameList]);
  useEffect(() => {
    document.title = `Edit Email Rule`;
 },[])
  useEffect(() => {
    dispatch(getAssestListddlAction());
    dispatch(getEmailRules(ActiveTab, params.RuleId, true));
    dispatch(getCategory());
    getSecurityList();
    dispatch(getCrmDocumentTypesAction());
  }, []);
  useEffect(() => {
    if (emailRule.IsStandardConfiguration) {
      const attach = securityItem.filter(item => item.EmailAttachmentSecurityId === emailRule.EmailAttachmentSecurityId);
      if (attach.length > 0) {
        setSelectedSecurityItem({
          AssetName: attach[0]?.AssetName,
          EmailAttachmentSecurityId: attach[0]?.EmailAttachmentSecurityId
        });
      }
    }
  }, [emailRule]);
  useEffect(() => {
    if (EmailRules.length > 0) {
      setEmailRule(EmailRules[0]);
      setSelectedCaterogy({
        "ActivityEntityTypeId": 0,
        "ActivityEntityType": null,
        "ActivityTypeId": 0,
        "ActivityType": null,
        "ActivitySubTypeId": parseInt(EmailRules[0]?.DocumentTypeId),
        "ActivitySubType": EmailRules[0]?.DocumentType
      }
      );
      //SetAccountName({TaxEntityId: EmailRules[0]?.AccountIdList, TaxEntityName: EmailRules[0]?.AccountName});
      setselectedAssetId(EmailRules[0]?.AssetIdList);
      SetClientAssetId({ AssetId: EmailRules[0]?.AssetIdList, AssetName: EmailRules[0]?.AssetNameList });
      SetClientDocumentTypeId({ DocumentTypeId: EmailRules[0]?.DocumentTypeId, TypeName: EmailRules[0]?.DocumentType });
      SetSubjectOverride(EmailRules[0]?.SubjectOverride);
      SetDateOverrideFormat(EmailRules[0]?.DateOverideFormat);
      SetIsStandardConfiguration(EmailRules[0]?.IsStandardConfiguration);
      SetShowAttachmentOnly(EmailRules[0]?.IsAttachmentOnly);
      SetLinkedEmail(EmailRules[0]?.IsLinkedEmail);
      const fieldDetails = EmailRules[0]?.LinkedEmailFieldId !== null ? EmailRules[0]?.LinkedEmailFieldId : null;
      SetField({ value: fieldDetails, label: fieldDetails === 1 ? "Subject" : fieldDetails === 2 ? "Body" : fieldDetails === 3 ? "Attachment" : "" });
      SetFieldContains(EmailRules[0]?.LinkedEmailFieldContain);
      const AssetId = EmailRules[0]?.AssetIdList.split(',');
      const AssetString = EmailRules[0]?.AssetNameList.split(',')
      const inEmailRuleAsset = AssetId.map((item, index) => {
        return {
          AccountTypeId: null,
          AssetType: null,
          AssetValue: null,
          AssetId: parseInt(item),
          AssetName: AssetString[index],
        }
      });
      setSelectedAssets([...inEmailRuleAsset]);
      const AccountId = EmailRules[0]?.AccountIdList.length > 0 ? EmailRules[0]?.AccountIdList.split(',') : [];
      const AccountName = EmailRules[0]?.AccountName.split('|');
      const inEmailRuleAccount = AccountId.map((item, index) => {
        return {
          "TaxEntityId": parseInt(item),
          "TaxEntityName": AccountName[index]
        }
      });
      SetAccountName([...inEmailRuleAccount]);
      setSelectedDateOverrideOption(EmailRules[0]?.DateOverrideBy);
    }
  }, [EmailRules]);

  const closeModal = () => {
    setShowModal(false);
  };
  const AttachAssetDDChanged = (e) => {
    setPasswordData({ ...e.value, Password: passwordData.Password, EmailAttachmentSecurityId: passwordData.EmailAttachmentSecurityId })
  };

  const NavigatetoEmailRules = () => {
    history(`${UrlPath.EmailRulesList}${localAssetId}`, {
      state: ActiveTab
    });
  };

  const UpdateEmailRules = (event) => {
    let saveSuccess = true;
    let AssetIds = '';
    let AssetNames = '';
    let AssetIdsArray = '';
    selectedAssets.map((item, index) => {
      if (index + 1 == selectedAssets.length) {
        AssetIds += item.AssetId;
        AssetNames += item.AssetName;
      }
      else {
        AssetIds = `${AssetIds},${item.AssetId}`;
        AssetNames = `${AssetNames},${item.AssetName}`;
      }
    });
    let selectedAssetsArray = selectedAssets
      .filter(item => !isNaN(item.AssetId))
      .map(item => ({
        AssetId: item.AssetId,
        AssetName: item.AssetName,
      }));

    let assetIdArray = selectedAssetsArray.map(item => item.AssetId);
    const AccountIds = accountName.map((Ids) => Ids.TaxEntityId);

    AssetIdsArray = assetIdArray.join(',');

    const saveData = {
      "emailRuleId": emailRule.EmailRuleId,
      "emailRuleName": emailRule.EmailRuleName,
      "emailRuleTypeId": emailRule.EmailRuleTypeId,
      "isActive": true,
      "filterFromAddresses": emailRule.FilterFromAddresses,
      "filterToAddresses": emailRule.FilterToAddresses,
      "filterCCAddresses": emailRule.FilterCCAddresses,
      "filterFromDomains": emailRule.FilterFromDomains,
      "filterSubjectContains": emailRule.FilterSubjectContains,
      "filterBodyContains": emailRule.FilterBodyContains,
      "filterAttachmentContains": emailRule.FilterAttachmentContains,
      "accountIdList": AccountIds === "undefined" || AccountIds === NaN ? null : AccountIds.join(','),
      "assetIdList": ActiveTab === 1 ? AssetIdsArray === NaN ? null : AssetIdsArray : selectedAssetId,
      "documentTypeId": emailRule.DocumentTypeId,
      "sourceEmail": emailRule.SourceEmail,
      "subjectOverride": emailRule.SubjectOverride,
      "dateOverrideFormat": emailRule.DateOverideFormat,
      "isAttachmentOnly": emailRule.IsAttachmentOnly,
      "isLinkedEmail": emailRule.IsLinkedEmail,
      "linkedEmailFieldId": emailRule.IsLinkedEmail ? emailRule.LinkedEmailFieldId : null,
      "linkedEmailFieldContain": emailRule.IsLinkedEmail ? emailRule.LinkedEmailFieldContain : null,
      "isStandardConfiguration": emailRule.IsStandardConfiguration,
      "emailAttachmentSecurityId": emailRule.IsStandardConfiguration ? selectedSecurityItem?.EmailAttachmentSecurityId : 0,
      "priority": 0,
      "dateOverrideBy": selectedDateOverrideOption,
      "modifiedBy": 0
    }
    if (ActiveTab === 1) {
      if (!saveData.emailRuleName || AssetIdsArray.length < 1 || !emailRule.DocumentTypeId) {
        SBNotify({ Msg: "Please enter all the mandatory", type: "warning" });
        saveSuccess = false;
      }
      else if (!emailRule.FilterFromAddresses && !emailRule.FilterFromDomains) {
        SBNotify({ Msg: 'At least From Address or From Domains field needs to be filled.', type: "warning" });
        saveSuccess = false;
      }
      /*else if (!emailRule.FilterSubjectContains && !emailRule.FilterBodyContains) {
        saveSuccess = false;
        SBNotify({ Msg: 'At least Subject Contains or Body Contains field needs to be filled.', type: "warning" });
      }*/
    }
    else if (ActiveTab === 2)
    {

      if (!saveData.emailRuleName) {
        SBNotify({ Msg: "Please enter Email Rule Name", type: "warning" });
        saveSuccess = false;
      }
      else if (!emailRule.FilterFromAddresses && !emailRule.FilterFromDomains) {
          SBNotify({ Msg: 'At least From Address or From Domains field needs to be filled.', type: "warning" });
          saveSuccess = false;
      }
      /*else if (!emailRule.FilterSubjectContains && !emailRule.FilterBodyContains) {
        saveSuccess = false;
        SBNotify({ Msg: 'At least Subject Contains or Body Contains field needs to be filled.', type: "warning" });
      }*/
      else if (AccountIds.length < 1) {
        SBNotify({ Msg: "Please Select Account Name", type: "warning" });
        saveSuccess = false;
      }
      else if (emailRule.IsLinkedEmail) {
        if (!emailRule.LinkedEmailFieldId) {
          SBNotify({ Msg: "please select field", type: "warning" });
          saveSuccess = false
        }
        else if (!emailRule.LinkedEmailFieldContain) {
          SBNotify({ Msg: "Contains Should not be Empty", type: "warning" });
          saveSuccess = false
        }

      }
       if (saveData.isStandardConfiguration) {
        if (securityItem.length < 1) {
          SBNotify({ Msg: "Please Add  the Attachment Password", type: "warning" });
          saveSuccess = false
        }
        else if (!selectedSecurityItem) {
          SBNotify({ Msg: "Please Select  the Attachment Password", type: "warning" });
          saveSuccess = false
        }
      }
    }

    else if (ActiveTab === 3) {
      if (!saveData.emailRuleName) {
        SBNotify({ Msg: "Please enter all the mandatory", type: "warning" });
        saveSuccess = false;
      }
      else if (!emailRule.FilterFromAddresses && !emailRule.FilterFromDomains) {
        SBNotify({ Msg: 'At least From Address or From Domains field needs to be filled.', type: "warning" });
        saveSuccess = false;
      }
      /*else if (!emailRule.FilterSubjectContains && !emailRule.FilterBodyContains) {
        saveSuccess = false;
        SBNotify({ Msg: 'At least Subject Contains or Body Contains field needs to be filled.', type: "warning" });
      }*/
    }
    if (saveSuccess) {
      sbaAxios({
        url: `${EmailruleInsertorUpdate}`,
        method: 'post',
        data: saveData,
      })
        .then((response) => {
          SBNotify({ type: 'success', Msg: 'Email Rules Updated Successfully' });
          setTimeout(() => {
            history(`${UrlPath.EmailRulesList}${localAssetId}`, {
              state: ActiveTab
            });
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });
    }

  };

  const Level = [
    { BreadCrumb: "Email Rules >", Routes: `${UrlPath.EmailRulesList}${localAssetId}` },
    { BreadCrumb: "Edit Rules", Routes: `${UrlPath.EditEmailRules}${params.RuleId}` },
  ];
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEmailRule({
      ...emailRule,
      [name]: value,
    });
  };
  const configModal = (Mode) => {
    setShowModal(true);
    if (Mode === "Edit") {
      setExistingAttachment(true);
      setPasswordData({
        "AssetType": null,
        "AssetValue": null,
        "AssetId": selectedSecurityItem.AssetId,
        "AssetName": selectedSecurityItem.AssetName,
        "AccountTypeId": null,
        "Password": selectedSecurityItem.SecretKey,
        "EmailAttachmentSecurityId": selectedSecurityItem.EmailAttachmentSecurityId
      })
    }
    else {
      setExistingAttachment(false);
      setPasswordData(PasswordMeta);
    }
  }
  const securityItemChange = (e) => {
    setSelectedSecurityItem(e.value);
  }
  const AssetDDChanged = (e) => {
    setSelectedAssets([...e.value])
  }
  const standardoncheck = (e) => {
    setEmailRule({
      ...emailRule,
      IsStandardConfiguration: e.target.checked
    })
    SetIsStandardConfiguration(e.target.checked)
  }
  const CategoryChanged = (e) => {
    setSelectedCaterogy(e.value);
    setEmailRule({
      ...emailRule,
      DocumentType: e.value.ActivitySubType,
      DocumentTypeId: e.value.ActivitySubTypeId
    })
  };
  const PasswordChanged = (e) => {
    setPasswordData({ ...passwordData, Password: e.target.value });
  };
  const UpdateEmailAttachment = (e) => {
    const data = {
      "EmailAttachmentSecurityId": passwordData.EmailAttachmentSecurityId || 0,
      "AssetId": passwordData.AssetId,
      "SecretKey": passwordData.Password,
      "ModifiedBy": 38
    };

    if (!passwordData.Password || !passwordData.AssetId) {
      SBNotify({ Msg: "Please enter the All the fields", type: "warning" })
    }
    else {
      sbaAxios({
        url: `${InsertOrUpdateEmailAttachmentSecurity}`,
        method: 'post',
        data: data,
      })
        .then((responseData) => {
          let message;
          if (data.EmailAttachmentSecurityId == 0) {
            message = 'Password Attachment Saved Successfully';
          }
          else {
            message = 'Password Attachment Updated Successfully';
          }
          SBNotify({ Msg: message, type: 'success' })
          getSecurityList();
          setShowModal(false);
          setSelectedSecurityItem({
            "EmailAttachmentSecurityId": responseData,
            "AssetId": data.AssetId,
            "AssetName": passwordData.AssetName,
            "SecretKey": passwordData.Password,
            "ModifiedBy": 0,
            "ModifiedDate": "0001-01-01T00:00:00"
          });
        })
        .catch((error) => {
          console.log(error);
        });

    }
  };

  const txtAccountName = (event) => {
    setEmailRule({
      ...emailRule,
      AccountIds: event.value.TaxEntityId,
      AccountName: event.value.TaxEntityName,
    })
    SetAccountName(event.value);
  };
  const getTaxEntities = (e) => {
    const SearchTerm = e.filter.value;
    if (SearchTerm.length > 0) dispatch(getTaxEntitiesAction(SearchTerm));
  };
  const ClientAssetNameonChange = (event) => {
    setEmailRule({
      ...emailRule,
      AssetIdList: event.value.AssetId,
      AssetNameList: event.value.AssetName,
    })
    SetClientAssetId(event.value);
    setselectedAssetId(event.value.AssetId);
  };
  const ClientDocumentTypeonChange = (event) => {
    setEmailRule({
      ...emailRule,
      DocumentTypeId: event.value.DocumentTypeId,
      DocumentType: event.value.TypeName,
    })
    SetClientDocumentTypeId(event.value);
  };
  const txtSubjectOverrideChange = (event) => {
    setEmailRule({
      ...emailRule,
      SubjectOverride: event.target.value,
    })
    SetSubjectOverride(event.target.value);
  };
  const txtDateOverrideFormatChange = (event) => {
    setEmailRule({
      ...emailRule,
      DateOverideFormat: event.target.value,
    })
    SetDateOverrideFormat(event.target.value);
  };
  const attachmentoncheck = () => {
    var config = $("#attachmentonly").prop("checked");
    if (config === true) {
      SetShowAttachmentOnly(true);
    } else {
      SetShowAttachmentOnly(false);
    }
    setEmailRule({
      ...emailRule,
      IsAttachmentOnly: config,
    })
  };
  const linkedEmailOncheck = () => {
    var config = $("#linkedEmail").prop("checked");
    if (config === true) {
      SetLinkedEmail(true);
    } else {
      SetLinkedEmail(false);
    }
    setEmailRule({
      ...emailRule,
      IsLinkedEmail: config,
    })
  };
  const dateOverrideByOnChange = (value) => {
    setSelectedDateOverrideOption(value)
  };
  const fieldDropdown = [
    { value: "1", label: "Subject" },
    { value: "2", label: "Body" },
    { value: "3", label: "Attachment" },
  ];
  const FieldOnChange = (event) => {
    setEmailRule({
      ...emailRule,
      LinkedEmailFieldId: event.value.value,
    })
    SetField(event.value);
  };
  const txtFieldContainsChange = (event) => {
    setEmailRule({
      ...emailRule,
      LinkedEmailFieldContain: event.target.value,
    })
    SetFieldContains(event.target.value);
  };

  return (
    <>
      <TopBar label={"Edit Email Rule"} />
      <div id="content" class="asset-detail-screen mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="p-3">
          <div id="manfield" className="p-3 bg-white life-science rounded">
            <div className="row gap-3">
              <div className="col-md-4">
                <div>
                  <label className="label">Source Type</label>
                  <input
                    className="form-control w-75"
                    type="text"
                    value={
                      ActiveTab === 1
                        ? "Investment"
                        : ActiveTab === 2
                          ? "Client"
                          : "Deletion"
                    }
                    disabled
                  />
                </div>
                <div className="my-4">
                  <label className="label">
                    Rule Name<span className="mandatory">*</span>
                  </label>
                  <input
                    className="form-control w-75"
                    type="text"
                    name="EmailRuleName"
                    onChange={handleInputChange}
                    value={emailRule?.EmailRuleName}
                  />
                </div>
                <div
                  id="manfield"
                  className="p-3 bg-white life-science rounded"
                >
                  Filtering Rules
                  <div className="my-4">
                    <label className="label">From Addresses</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      name="FilterFromAddresses"
                      onChange={handleInputChange}
                      value={emailRule?.FilterFromAddresses}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">To Addresses</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      name="FilterToAddresses"
                      onChange={handleInputChange}
                      value={emailRule?.FilterToAddresses}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">cc Addresses</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      name="FilterCCAddresses"
                      onChange={handleInputChange}
                      value={emailRule?.FilterCCAddresses}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">From Domains</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      name="FilterFromDomains"
                      onChange={handleInputChange}
                      value={emailRule?.FilterFromDomains}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">Subject Contains</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      name="FilterSubjectContains"
                      onChange={handleInputChange}
                      value={emailRule?.FilterSubjectContains}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">Body Contains</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      name="FilterBodyContains"
                      onChange={handleInputChange}
                      value={emailRule?.FilterBodyContains}
                    />
                  </div>
                  {/* {ActiveTab !== 3 && ( */}
                     <div className="my-4">
                     <label className="label">Attachment Contains</label>
                     <input
                       className="form-control w-75"
                       type="text"
                       name="FilterAttachmentContains"
                       onChange={handleInputChange}
                       value={emailRule?.FilterAttachmentContains}
                     />
                   </div> 
                    {/* )} */}
                </div>
              </div>
              <div className="col-md-4">
                {ActiveTab === 1 && (
                  <div className="my-4">
                    <label className="label">
                      Asset Name<span className="mandatory">*</span>
                    </label>
                    <div>
                      <SBAMultiSelectCheck
                        data={AssetListDDL}
                        dataItemKey="AssetId"
                        textField="AssetName"
                        className="w-75"
                        onChange={AssetDDChanged}
                        value={selectedAssets}
                        tags={
                          selectedAssets.length > 0
                            ? [
                              {
                                text: `${selectedAssets.length} items selected`,
                                data: [...selectedAssets],
                              },
                            ]
                            : []
                        }
                        filterable={true}
                      ></SBAMultiSelectCheck>
                    </div>
                  </div>
                )}
                {ActiveTab === 1 && (
                  <div className="my-4">
                    <label className="label">
                      Document Type <span className="mandatory">*</span>
                    </label>
                    <div style={{ width: "75%" }}>
                      <SBADropDown
                        textField={"ActivitySubType"}
                        valueField={"ActivitySubTypeId"}
                        value={selectedCaterogy}
                        data={Category}
                        onChange={CategoryChanged}
                      />
                    </div>
                  </div>
                )}

                {ActiveTab === 2 && (
                  <>
                    {/* //   <div className="my-4">
                  //     <label>
                  //       <input
                  //         type="radio"
                  //         value="account"
                  //         checked={selectedOption === "account"}
                  //       />
                  //       Account
                  //     </label>
                  //   </div> */}
                    <div className="my-4">
                      <label className="label">Account Name<span className="mandatory">*</span></label>
                      <div>
                        <SBAMultiSelectCheck
                          data={accounts}
                          valueField="TaxEntityId"
                          textField="TaxEntityName"
                          className="w-75"
                          value={accountName}
                          onFilterChange={getTaxEntities}
                          onChange={txtAccountName}
                        // tags={
                        //   accountName?.length > 0
                        //     ? [
                        //         {
                        //           text: `${accountName?.length} items selected`,
                        //           data: [...accountName],
                        //         },
                        //       ]
                        //     : []
                        // }
                        />
                      </div>
                    </div>
                    <div className="my-4">
                      <label className="label">
                        Asset Name
                      </label>
                      <div style={{ width: "75%" }}>
                        <SBAComboBox
                          textField={"AssetName"}
                          valueField={"AssetId"}
                          data={AssetDataItems}
                          value={clientAssetId}
                          onChange={ClientAssetNameonChange}
                        />
                      </div>
                    </div>
                    <div className="my-4">
                      <label className="label">
                        Document Type<span className="mandatory">*</span>
                      </label>
                      <div style={{ width: "75%" }}>
                        <SBADropDown
                          textField={"TypeName"}
                          valueField={"DocumentTypeId"}
                          data={DocumentTypesData}
                          value={clientDocumentTypeId}
                          onChange={ClientDocumentTypeonChange}
                        />
                      </div>
                    </div>
                  </>
                )}

                {ActiveTab === 1 ||
                  (ActiveTab === 2 && (
                    <div className="my-4">
                      <label className="label">Source/Email</label>
                      <input
                        className="form-control w-75"
                        type="text"
                        name="SourceEmail"
                        onChange={handleInputChange}
                        value={emailRule?.SourceEmail}
                      />
                    </div>
                  ))}

                {ActiveTab === 2 && (
                  <>
                    <div className="my-4">
                      <label className="label">Subject Override</label>
                      <input
                        className="form-control w-75"
                        type="text"
                        value={subjectOverride}
                        onChange={txtSubjectOverrideChange}
                      />
                    </div>

                    <div
                      id="manfield"
                      className="p-3 bg-white life-science rounded"
                    >
                      <div className="mb-4">
                        <label className="label">Date Override</label>
                        <input
                          className="form-control w-75"
                          type="text"
                          value={dateOverrideFormat}
                          onChange={txtDateOverrideFormatChange}
                        />
                      </div>

                      <div>
                        <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="radio"
                            value="overridesubject"
                            checked={
                              selectedDateOverrideOption === 1
                            }
                            onClick={() => dateOverrideByOnChange(1)}
                            style={{ marginRight: "10px" }}
                          />
                          Override Subject
                        </label>
                      </div>

                      <div>
                        <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="radio"
                            value="overridebody"
                            checked={
                              selectedDateOverrideOption === 2
                            }
                            onClick={() => dateOverrideByOnChange(2)}
                            style={{ marginRight: "10px" }}
                          />
                          Override Body
                        </label>
                      </div>

                      <div>
                        <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="radio"
                            value="overrideattachment"
                            checked={
                              selectedDateOverrideOption === 3
                            }
                            onClick={() => dateOverrideByOnChange(3)}
                            style={{ marginRight: "10px" }}
                          />
                          Override Attachment
                        </label>
                      </div>
                    </div>

                    <div className="my-4">
                      <label style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="me-1"
                          type="checkbox"
                          checked={linkedEmail}
                          onClick={linkedEmailOncheck}
                          id="linkedEmail"
                        />
                        <span>Linked Email</span>
                      </label>
                    </div>
                    {linkedEmail && (
                      <>
                        <div>
                          <div>
                            <label className="label">Field<span className="mandatory">*</span></label>
                            <div>
                              <SBADropDown
                                className="form-control w-50"
                                textField={"label"}
                                valueField={"value"}
                                data={fieldDropdown}
                                value={field}
                                onChange={FieldOnChange}
                              />
                            </div>
                          </div>
                          <div>
                            <label className="label">Contains<span className="mandatory">*</span></label>
                            <input
                              className="form-control w-50"
                              type="text"
                              value={fieldContains}
                              onChange={txtFieldContainsChange}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

                {ActiveTab === 1 ||
                  (ActiveTab === 2 && (
                    <div className="my-4">
                      <label style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="me-1"
                          type="checkbox"
                          id="stdconfig"
                          checked={isStandardConfiguration}
                          onChange={standardoncheck}
                        />
                        <span>Standard Configuration</span>
                      </label>
                    </div>
                  ))}
                <div className="my-4">
                  {emailRule.IsStandardConfiguration && (
                    <div>
                      <label className="label">Attachment Password<span className="mandatory">*</span></label>
                      <div className="col-lg-12 d-flex gap-3  p-0 align-items-center">
                        <div style={{ width: "75%" }}>
                          <SBADropDown
                            value={selectedSecurityItem}
                            data={securityItem}
                            textField={"AssetName"}
                            valueField={"EmailAttachmentSecurityId"}
                            onChange={securityItemChange}
                          ></SBADropDown>
                        </div>
                        <div
                          className="d-flex gap-4"
                          style={{ marginTop: "-4%" }}
                        >
                          <div
                            className="position-absolute edit_iconShareClass"
                            onClick={() => configModal("Edit")}
                          >
                            <i class="fa-solid fa-pencil SBA_icon"></i>
                          </div>
                        </div>
                        <div className="d-flex gap-4"></div>
                        <div
                          className="d-flex gap-2"
                          style={{ marginTop: "-4%" }}
                        >
                          <div
                            className="position-absolute add_iconShareClass"
                            onClick={() => configModal("Add")}
                          >
                            <i class="fa-solid fa-add SBA_icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {ActiveTab === 2 && (
                  <div className="my-4">
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        className="me-1"
                        type="checkbox"
                        checked={showAttachmentOnly}
                        onClick={attachmentoncheck}
                        id="attachmentonly"
                      />
                      <span>Attachment Only</span>
                    </label>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-12 d-flex gap-12 justify-content-lg-end p-0 align-items-center">
              <button className="s-sm-btn mx-1" onClick={NavigatetoEmailRules}>
                Cancel
              </button>
              <button
                className="p-sm-btn mx-1"
                onClick={UpdateEmailRules}
                disabled={!isEditable}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal}>
        <Modal.Header closeButton onClick={closeModal}>
          <Modal.Title>Attachment Password Config</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <label className="label">Asset Name</label>
            <div style={{ width: "75%" }}>
              <AssetDropDown
                value={passwordData}
                onChange={AttachAssetDDChanged}
                data={AssetListDDL.sort((a, b) =>
                  a.AssetName.localeCompare(b.AssetName)
                )}
                popupSettings={{ style: "z-index:1051", className: "modalDD" }}
                disabled={existingAttachment}
              />
            </div>
            <label className="label">Password</label>
            <div className="align-items-center d-flex">
              <input
                className="form-control w-75"
                type={showText ? "text" : "password"}
                Value={passwordData.Password}
                onChange={PasswordChanged}
              />
              <span
                onClick={toggleTextVisibility}
                style={{ paddingLeft: "5px" }}
              >
                {showText ? (
                  <i class="fa-solid fa-eye"></i>
                ) : (
                  <i class="fa-regular fa-eye-slash"></i>
                )}
              </span>
                      </div>
                      <ToastContainer></ToastContainer>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="s-sm-btn mx-1" onClick={closeModal}>
            Cancel
          </button>
          <button className="p-sm-btn mx-1" onClick={UpdateEmailAttachment}>
            Save
          </button>
        </Modal.Footer>
      </Modal>
      <ToastContainer></ToastContainer>
    </>
  );
}